import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { LoadDots } from '../Button';

type AsyncProps = {
    children: JSX.Element;
    skelton?: JSX.Element;
    data?: any;
    labelWhileLoading?: string;
};

function AsyncLoader({ children, skelton, data = null, labelWhileLoading = '' }: AsyncProps) {
    const [loading, setLoading] = useState<boolean>(data === null || data === 'undefined');
    useEffect(() => {
        if (!(data === null || data === 'undefined')) {
            setLoading(false);
            return;
        }
        let timer: any;
        timer = setTimeout(() => {
            setLoading(false);
        }, 5 * 1000 * 60);
        return () => clearTimeout(timer);
    }, [data]);
    if (loading) return skelton ? skelton : <LoadDots labelWhileLoading={labelWhileLoading} />;
    return <React.Fragment>{children}</React.Fragment>;
}

export default AsyncLoader;
